export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const COMMITS_AUTHORS = 'COMMITS_AUTHORS';
